import Sidebar from "../../slices/assets/Sidebar";

const assetsReducer = {
    sidebar: Sidebar,
};

export default assetsReducer;